export default "__VITE_ASSET__9XqBolBi__"